import translate from '../i18n/config';

export const API_PREFIX = '/api/';

export const API_URL = process.env.REACT_APP_API_URL;

const ENTITY = {
  auth: 'auth',
  users: 'user',
  roles: 'role',

  genericLookup: 'generic-lookup',
  developers: 'developer',
  country: 'country',
  state: 'state',
  city: 'city',
  area: 'area',
};

export const PATH = {
  login: 'login',
  logout: 'logout',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  search: 'search',
  lookup: 'lookup',
  changePassword: 'change-password',
  kpis: 'kpi',
  verifyOtp: 'verify-otp',
};

const API_PATHS = {
  login: `${ENTITY.auth}/${PATH.login}`,
  logout: `${ENTITY.auth}/${PATH.logout}`,
  forgotPassword: `${ENTITY.auth}/${PATH.forgotPassword}`,
  resetPassword: `${ENTITY.auth}/${PATH.resetPassword}`,
  listUsers: `${ENTITY.users}/${PATH.search}`,
  users: `${ENTITY.users}`,
  changePassword: `${ENTITY.users}/${PATH.changePassword}`,
  userListKpis: `${ENTITY.users}/${PATH.kpis}`,
  listRoles: `${ENTITY.roles}/${PATH.search}`,
  lookupUsers: `${ENTITY.users}/${PATH.lookup}`,
  lookupRoles: `${ENTITY.roles}/${PATH.lookup}`,
  lookupGeneric: `${ENTITY.genericLookup}/${PATH.lookup}`,
  lookupCountries: `${ENTITY.country}/${PATH.lookup}`,
  lookupStates: `${ENTITY.state}/${PATH.lookup}`,
  lookupCities: `${ENTITY.city}/${PATH.lookup}`,
  lookupAreas: `${ENTITY.area}/${PATH.lookup}`,

  listDevelopers: `${ENTITY.developers}/${PATH.search}`,
  developers: `${ENTITY.developers}`,
  verifyOtp: `${ENTITY.auth}/${PATH.verifyOtp}`,
  developerKpis: `${ENTITY.developers}/${PATH.kpis}`,
  lookupDevelopers: `${ENTITY.developers}/${PATH.lookup}`,
  syncGovernmentProjects: 'property/sync-government-projects',
  agentExport:            'agent/export',
  developerExport:        'developer/export',
};

export const API_ENDPOINTS = {
  login: API_PREFIX + API_PATHS.login,
  logout: API_PREFIX + API_PATHS.logout,
  forgotPassword: API_PREFIX + API_PATHS.forgotPassword,
  resetPassword: API_PREFIX + API_PATHS.resetPassword,
  listUsers: API_PREFIX + API_PATHS.listUsers,
  addUser: API_PREFIX + API_PATHS.users,
  editUser: API_PREFIX + API_PATHS.users,
  changePassword: API_PREFIX + API_PATHS.changePassword,
  getUser: API_PREFIX + API_PATHS.users,
  lookupUsers: API_PREFIX + API_PATHS.lookupUsers,
  userListKpis: API_PREFIX + API_PATHS.userListKpis,
  listRoles: API_PREFIX + API_PATHS.listRoles,
  lookupRoles: API_PREFIX + API_PATHS.lookupRoles,
  lookupGeneric: API_PREFIX + API_PATHS.lookupGeneric,
  lookupCountries: API_PREFIX + API_PATHS.lookupCountries,
  lookupStates: API_PREFIX + API_PATHS.lookupStates,
  lookupCities: API_PREFIX + API_PATHS.lookupCities,
  lookupAreas: API_PREFIX + API_PATHS.lookupAreas,

  listDevelopers: API_PREFIX + API_PATHS.listDevelopers,
  addDeveloper: API_PREFIX + API_PATHS.developers,
  editDeveloper: API_PREFIX + API_PATHS.developers,
  getDeveloper: API_PREFIX + API_PATHS.developers,
  developerKpis: API_PREFIX + API_PATHS.developerKpis,
  lookupDevelopers: API_PREFIX + API_PATHS.lookupDevelopers,
  verifyOtp: API_PREFIX + API_PATHS.verifyOtp,
  listProperties: API_PREFIX + 'property/' + PATH.search,
  addProperty: API_PREFIX + 'property',
  editProperty: API_PREFIX + 'property',
  getProperty: API_PREFIX + 'property',
  deleteProperty: API_PREFIX + 'property',
  propertyKpis: API_PREFIX + 'property/' + PATH.kpis,
  propertyTypeLookup: API_PREFIX + 'property-type/' + PATH.lookup,
  amenityLookup: API_PREFIX + 'amenity/' + PATH.lookup,
  categoryLookup: API_PREFIX + 'category/' + PATH.lookup,
  propertyDocs: API_PREFIX + 'property-doc/doc-types',
  propertyDoc: API_PREFIX + 'property-doc',
  syncGovernmentProjects: API_PREFIX + API_PATHS.syncGovernmentProjects,
  agentExport:            API_PREFIX + API_PATHS.agentExport,
  developerExport:        API_PREFIX + API_PATHS.developerExport,
};

export const STATUS_CODE = {
  unauthorized: 401,
  badRequest: 400,
  unProcessableEntity: 422,
  forbidden: 403,
  notFound: 404,
  internalServerError: 500,
  gatewayTimeout: 504,
  entityTooLarge: 413,
  conflict: 409,
};

export const ERROR_MESSAGES = {
  internalServerError: translate.t('common.errorMessages.internalServerError'),
  unauthorized: translate.t('common.errorMessages.unauthorized'),
  badRequest: translate.t('common.errorMessages.badRequest'),
  apiPathNotFound: translate.t('common.errorMessages.apiPathNotFound'),
  forbidden: translate.t('common.errorMessages.forbidden'),
  gatewayTimeout: translate.t('common.errorMessages.gatewayTimeout'),
};
